import React, { useState, useEffect } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line, Bar, Pie } from "react-chartjs-2";
import "./UserProgress.css";

// Register ChartJS components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Title,
  Tooltip,
  Legend
);

const UserProgress = () => {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);

  useEffect(() => {
    // Simulate data loading
    setTimeout(() => {
      setData({
        totalUsers: 12450,
        activeUsers: 8920,
        profileCompletion: 76,
        verifiedUsers: 9340,
      });
      setLoading(false);
    }, 500);
  }, []);

  if (loading) {
    return (
      <div className="user-progress">
        <h1>User Progress</h1>
        <div className="loading-container">
          <div className="spinner"></div>
          <p>Loading user progress data...</p>
        </div>
      </div>
    );
  }

  const profileCompletionData = {
    labels: ["Completed", "Incomplete"],
    datasets: [{
      data: [data.profileCompletion, 100 - data.profileCompletion],
      backgroundColor: ["#4caf50", "#e0e0e0"],
    }],
  };

  const userGrowthData = {
    labels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun"],
    datasets: [{
      label: "New Users",
      data: [1200, 1900, 1500, 2200, 1800, 2400],
      borderColor: "#2196f3",
      backgroundColor: "rgba(33, 150, 243, 0.1)",
      tension: 0.4,
    }],
  };

  return (
    <div className="user-progress">
      <div className="analytics-header">
        <h1>User Progress Analytics</h1>
      </div>

      <div className="analytics-grid">
        <div className="analytics-card">
          <div className="card-icon total">
            <span className="material-icons">people</span>
          </div>
          <div className="card-content">
            <h3>Total Users</h3>
            <p className="metric-value">{data.totalUsers.toLocaleString()}</p>
          </div>
        </div>

        <div className="analytics-card">
          <div className="card-icon users">
            <span className="material-icons">person_check</span>
          </div>
          <div className="card-content">
            <h3>Active Users</h3>
            <p className="metric-value">{data.activeUsers.toLocaleString()}</p>
          </div>
        </div>

        <div className="analytics-card">
          <div className="card-icon completion">
            <span className="material-icons">task_alt</span>
          </div>
          <div className="card-content">
            <h3>Profile Completion</h3>
            <p className="metric-value">{data.profileCompletion}%</p>
          </div>
        </div>

        <div className="analytics-card">
          <div className="card-icon verified">
            <span className="material-icons">verified_user</span>
          </div>
          <div className="card-content">
            <h3>Verified Users</h3>
            <p className="metric-value">{data.verifiedUsers.toLocaleString()}</p>
          </div>
        </div>
      </div>

      <div className="charts-grid">
        <div className="chart-card">
          <h3>User Growth Trend</h3>
          <div className="chart-container">
            <Line data={userGrowthData} options={{ responsive: true, maintainAspectRatio: false }} />
          </div>
        </div>

        <div className="chart-card">
          <h3>Profile Completion Rate</h3>
          <div className="chart-container pie-chart">
            <Pie data={profileCompletionData} options={{ responsive: true, maintainAspectRatio: false }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProgress;
